import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/Redux/Reducers";
import { ParentTabsRenderer } from "../ParentTabsRenderer";
import { useActiveTab } from "../../Hooks/useActiveTab";
import { useNavLinkList } from "../../Hooks/useNavLinkList";
import { UserAndStoreInfo } from "../UserAndStoreInfo";
import { DSBrandLogo } from "../DSBrandLogo";
import { NavigationBarProps } from "../../Types";
import { SidebarToggler } from "../Common";
import { StoreCredits } from "../StoreCredits";

function NavigationBar(props: NavigationBarProps) {
  const { expanded, setExpanded } = props;

  const { storeData } = useSelector((state: RootState) => ({
    storeData: state.storeReducer.store,
  }));

  const [tabState, setTabState] = useState({
    activeTabId: null,
    activeSubTabId: null,
    activeHoveredTabId: null,
    activeHoveredSubTabId: null,
    expandedParentTabId: null,
  });

  const [anchorEl, setAnchorEl] = useState(null);

  const { navLinkList } = useNavLinkList();

  const [hideToggler, setHideToggler] = useState(false);

  // handles current active tab in navigation bar
  useActiveTab({
    handleTabStateChange,
    currentActiveTab: tabState.activeTabId,
    currentActiveSubTab: tabState.activeSubTabId,
    setExpanded,
    setHideToggler,
  });

  function handleTabStateChange(partialTabStateData) {
    setTabState({
      ...tabState,
      ...partialTabStateData,
    });
  }

  return (
    <div className="tw-z-[9999] tw-flex tw-h-full tw-flex-col">
      {!hideToggler && <SidebarToggler expanded={expanded} onClick={() => setExpanded(!expanded)} />} <DSBrandLogo />
      <div className="tw-flex tw-flex-1 tw-flex-col tw-justify-between tw-overflow-y-auto tw-overflow-x-hidden tw-pb-[32px]">
        <div className="tw-flex tw-flex-col tw-gap-[2px]">
          {navLinkList.map((navLinkData) => 
            <ParentTabsRenderer
              key={navLinkData?.id}
              navLinkData={navLinkData}
              tabState={tabState}
              expanded={expanded}
              onHoverTab={(id) => handleTabStateChange({ activeHoveredTabId: id, activeHoveredSubTabId: null })}
              onHoverSubTab={(id) => handleTabStateChange({ activeHoveredSubTabId: id, activeHoveredTabId: null })}
              onExpandParentTab={(id) => handleTabStateChange({ expandedParentTabId: id })}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
            />,
          )}
        </div>
        <StoreCredits expanded={expanded} />
      </div>
      <UserAndStoreInfo expanded={expanded} storeName={storeData?.store_name} storeLogo={storeData?.logo_image} />
    </div>
  );
}

export default NavigationBar;
